import React from "react";
import { Flex, Text } from "@chakra-ui/react";

interface UnreadMessagesNotificationProps {
  unreadMessageCnt: number;
  onClickViewNotifications: () => void;
}

export const UnreadMessagesNotification: React.FC<UnreadMessagesNotificationProps> = ({
  unreadMessageCnt,
  onClickViewNotifications,
}) => {
  if (unreadMessageCnt <= 0) return null;

  return (
    <Flex
      h="30px"
      padding="0px 15px"
      alignItems="center"
      borderRadius="100px"
      bgColor="#F02828"
    >
      <Text
        fontSize="12px"
        lineHeight="12px"
        fontWeight="700"
        color="#FFF"
      >
        {unreadMessageCnt} New Messages
      </Text>
      <Text
        fontSize="12px"
        lineHeight="12px"
        fontWeight="400"
        color="#FFF"
        ml="25px"
        cursor="pointer"
        onClick={onClickViewNotifications}
        _hover={{
          textDecoration: "underline",
        }}
      >
        View
      </Text>
    </Flex>
  );
};
